import { Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { UploadImageButton } from '@hero/atoms';
import { UploadLogoModal } from '@hero/components/modals';
import { ImagePreview } from '@hero/molecules';
import { useGetBranding, useUpdateBranding } from '@hero/services/organization-service/hooks';

import * as S from './style';

export function CompanyLogo() {
  const { t } = useTranslation();
  const { data: { branding } = {} } = useGetBranding();
  const { mutateAsync: updateBranding } = useUpdateBranding();

  const [isUploadModalOpen, setIsUploadModalOpen] = React.useState(false);

  return (
    <S.CompanyLogo>
      <S.CompanyLogoTitle>
        <Typography variant="body1Bold">{t('companyLogo')}</Typography>
      </S.CompanyLogoTitle>
      <Typography variant="body2" color="fg" emphasis="weak">
        {t('logoDesc')}
      </Typography>
      <S.CompanyLogoBody>
        <UploadImageButton onUpload={() => setIsUploadModalOpen(true)} />
        {branding?.logoUrl && <ImagePreview src={branding.logoUrl} active showActions={false} />}
      </S.CompanyLogoBody>

      <UploadLogoModal
        isOpen={isUploadModalOpen}
        setIsOpen={setIsUploadModalOpen}
        uploadAction={({ cdnUrl }) =>
          updateBranding({
            branding: {
              logoUrl: cdnUrl
            }
          })
        }
      />
    </S.CompanyLogo>
  );
}
